import { Bodies, Body, World } from 'matter-js';
import Entity, { EntityOptions } from './entity';
import { Graphics, Sprite } from 'pixi.js';

export default class Checkpoint extends Entity {
  public checked: false;

  constructor(opts: EntityOptions) {
    super({ ...opts, width: 50, height: 100 });
    this.init();
    this.shouldUpdate = false;
    this.update();
  }

  public init = () => {
    const palette = [0x4ba3c3, 0x175676, 0xba324f, 0xd62839];
    this.color = palette[Math.floor(Math.random() * palette.length)];

    const body = Bodies.rectangle(this.x, this.y, this.width, this.height, {
      isStatic: true,
      isSensor: true,
      label: 'Checkpoint',
      entity: this,
      ...this.options,
    } as any);
    this.body = body;

    const shape = new Graphics();
    shape.beginFill(this.color);
    // shape.lineStyle(1, 0xffffff);
    shape.drawRect(0, 0, this.width, this.height);

    this.sprite = new Sprite((this.game.render.renderer as any).generateTexture(shape));
    this.sprite.anchor.x = 0.5;
    this.sprite.anchor.y = 0.5;
  };
}
